import { useNetworkStatus } from '../networkStatus';

export function OfflineBanner() {
  const status = useNetworkStatus();
  if (status === 'online') return null;

  const text = status === 'offline'
    ? '⚠ OFFLINE — runs save locally and sync when you reconnect'
    : '⚠ SERVER UNREACHABLE — runs save locally and sync later';

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        padding: '4px 8px',
        background: status === 'offline' ? '#aa3300' : '#aa5500',
        color: '#fff',
        fontSize: 10,
        textAlign: 'center',
        letterSpacing: '0.05em',
      }}
    >
      {text}
    </div>
  );
}
